import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsLocaleService } from 'ngx-foundation';
import { BsModalService } from 'ngx-foundation/modal';
import { BsModalRef } from 'ngx-foundation/modal/bs-modal-ref.service';
import { ProfileService } from '../_services/profiles.service';
import { SubmissioService } from '../_services/submission.service';
import { Profile } from '../_models/profile.model';
import { Subscription } from 'rxjs/Subscription';
import { SearchParameters } from '../_viewmodels/search-params.viewmodel';
import { SearchService } from '../_services/search.service';
import { TramiteAfiliado } from '../_models/tramite-afiliado.model';
import { User } from '../_models/user.model';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from '../_services/environment.service';
import { HttpErrorResponse } from '@angular/common/http';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { ModalService } from '../_services/modal.service';
import { Router } from '@angular/router';
import { forEach } from '@angular/router/src/utils/collection';
import { FileSubmission } from '../_models/fileSubmission.model';
import Swal from'sweetalert2';

@Component({
  selector: 'app-consultas',
  templateUrl: './consultas.component.html',
  styleUrls: ['./consultas.component.scss'],
  providers: [SearchService],
})
export class ConsultasComponent implements OnInit, OnDestroy {

  bodyText: string;
  modalRef: BsModalRef;
  
  error: boolean;
  loading: boolean;
  isEmpty: boolean;
  searchHasBeenMade: boolean;
  modalRadicado: string;
  currentProfile: Profile;
  currentUser: User;
  public isCollapsed = false;
  profileSubscription: Subscription;
  submissionSubscription: Subscription;
  submissionFilename: string;
  tramites: TramiteAfiliado[];
  showVerButton = true;
  tramiteActual:TramiteAfiliado;
  lineasDetalle: string[];
  faDownload = faDownload;

  constructor(
    private profilesService: ProfileService,
    private localeService: BsLocaleService,
    private searchService: SearchService,
    private submissionService: SubmissioService,
    private authenticationService: AuthenticationService,
    private envService: EnvironmentService,
    private modalService: BsModalService,
    private _modalService: ModalService,
    private router: Router) {
      this.showVerButton = this.envService.showDocumentViewer;
      this.localeService.use('es');
  }

  checkUserToken() {
    // let isTokenValid = false;
    this.authenticationService.checkUserToken()
      .subscribe((response: any) => {
        
      },
      error => {

      });
  }

  ngOnInit() {
    this.checkUserToken();
    this.bodyText = 'This text can be updated in modal 1';
    this.loading = false;
    this.error = false;
    this.isEmpty = false;
    this.searchHasBeenMade = false;
    this.currentProfile = this.profilesService.getSelectedProfile();
    // Subscribe to user's profile change
    this.profileSubscription = this.profilesService.selectedProfileSubject.subscribe(
      (profile: Profile) => {
        this.currentProfile = profile;
        this.currentUser = this.authenticationService.currentUserValue;
      }
    );
    this.tramites = [];
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

  cleanSearchFilters(form: NgForm) {
    form.resetForm();
  }

  async onSubmitSearch(form: NgForm) {
    this.loading = true;
    this.error = false;
    this.searchHasBeenMade = true;
    this.tramites = [];
    const fvalue = form.value;

    // Asignar fecha a primera hora del día escogido.
    if (fvalue.fechaTramiteDesde) {
      fvalue.fechaTramiteDesde.setHours(0, 0, 0);
    }
    // Asignar fecha a última hora del día escogido.
    if (fvalue.fechaTramiteHasta) {
      fvalue.fechaTramiteHasta.setHours(23, 59, 59);
    }

    const searchParameters: SearchParameters = new SearchParameters();
    searchParameters.tipoTramite = "";
    Object.assign(searchParameters, form.value as SearchParameters);
    // Cambiar Asignación Fecha Desde

    searchParameters.fechaTramiteDesde = fvalue.fechaTramiteDesde
      ? fvalue.fechaTramiteDesde.toISOString()
      : '';
    // Cambiar Asignación Fecha Hasta
    searchParameters.fechaTramiteHasta = fvalue.fechaTramiteHasta
      ? fvalue.fechaTramiteHasta.toISOString()
      : '';

    // INICIO Datos Obligatorios Para Consulta
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentProfile && this.currentUser) {
      // Asignar Perfil Actual
      searchParameters.currentProfileName = this.currentProfile.profile_name
        ? this.currentProfile.profile_name
        : '';
      // Asignar Tipo Identificacion Afiliado
      searchParameters.tipoIdfAfiliado = this.currentUser.TipoIdentificacion
        ? this.currentUser.TipoIdentificacion
        : '';
      // Asignar Número Identificación Afiliado
      searchParameters.idfAfiliado = this.currentUser.NoIdentificacion
        ? this.currentUser.NoIdentificacion
        : '';
      // Asignar Número de Identificación Empresa
      searchParameters.idfEmpresa = this.currentProfile.profile_company_id
        ? this.currentProfile.profile_company_id
        : '';
      if (this.currentProfile.profile_name == "Funcionario Subsidio"){
        searchParameters.idfEmpresa = fvalue.identificacion;
      }
    } else {
    }
    // FIN Datos Obligatorios Para Consulta
    this.checkUserToken();
    this.searchService.searchTramites(searchParameters).subscribe(
      response => {
        this.error = false;
        this.loading = false;
        if (response.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        this.tramites = response;
        if (searchParameters.tipoTramite === null || searchParameters.tipoTramite === ""){
          searchParameters.tipoTramite = "Certificado escolar";
          this.searchService.searchTramites(searchParameters).subscribe(
            response => {
              this.error = false;
              this.loading = false;
              if (this.isEmpty === true && response.length === 0) {
                this.isEmpty = true;
              } else {
                this.isEmpty = false;
              }
              response.forEach( tr =>{
                this.tramites.push(tr);
              })
            },
            error => {
              this.isEmpty = true;
              this.loading = false;
              this.error = true;
              const errorObject = error as HttpErrorResponse;
              if (errorObject.status === 401) {
                this.authenticationService.logout();
                this.router.navigate(['/logout']);
                // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
                // location.replace(logBackURL);
              }
            }
          );
        }
      },
      error => {
        this.isEmpty = true;
        this.loading = false;
        this.error = true;
        const errorObject = error as HttpErrorResponse;
        if (errorObject.status === 401) {
          this.authenticationService.logout();
          this.router.navigate(['/logout']);
          // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
          // location.replace(logBackURL);
        }
      }
    );
    
  }
  openModalSubmission(modalId: string, entryId:number){
    this.modalRadicado = "";
    this.loading = true;
    this.submissionService.getSubmissionUrl(entryId).subscribe(
      response =>{
        console.log(response.fileName);
        const URL: string = this.envService.urlPdf+response.fileName;
        this._modalService.open(modalId);
        const ifr: HTMLIFrameElement = document.createElement('iframe');
        ifr.setAttribute('id', 'embeeded-frame');
        ifr.setAttribute('frameborder', '0');
        ifr.setAttribute('width', '100%');
        ifr.setAttribute('height', '100%');
        document.getElementById('iframe-goes-here').appendChild(ifr);
        ifr.contentWindow.location.replace(URL);
        this.loading=false;
      }
    );
}
  verHistoria(modalId: string, tramite: TramiteAfiliado){
    this.tramiteActual = tramite;
    this.lineasDetalle = [];
    this._modalService.open(modalId);
          //const ifr: HTMLIFrameElement = document.createElement('iframe');
          const divElem: HTMLDivElement = document.createElement('div');
          divElem.setAttribute('id', 'embeded-div');
          divElem.setAttribute('frameborder', '1');
          divElem.setAttribute('width', '80%');
          divElem.setAttribute('height', '70%');
          divElem.style.overflow="auto";
          divElem.innerHTML = "";
          //document.getElementById('iframe-goes-here').removeChild(divElem);
          if (document.getElementById('iframe-goes-here').hasChildNodes){
            document.getElementById('iframe-goes-here');
          }
          while (document.getElementById('iframe-goes-here').firstChild){
            document.getElementById('iframe-goes-here').removeChild(document.getElementById('iframe-goes-here').firstChild);
          }
          document.getElementById('iframe-goes-here').appendChild(divElem);
          //ifr.contentWindow.location.replace(URL);
          var contenido = " <div class='tabs-panel is-active' id='results-panel'> <h5> Consulta de Tr&aacute;mite: ";
          contenido +=  tramite.radicado + "</h5> <div class='row'> <table> <tr> <td>Fecha de solicitud:</td> <td>";
          contenido += tramite.fecha + "</td> </tr> <tr> <td>Tipo de trámite:</td> <td>" + tramite.tipoTramite+"</td> </tr> <tr> <td>Afiliado:</td> <td>";
          contenido += tramite.nombreAfiliado + "</td> </tr> <tr> <td>Estado:</td> <td>"+tramite.estado+ "</td> </tr> </table></div>";
          if (tramite.estado == 'RECHAZADO' && tramite.causasRechazo){
            contenido += "<div class='row'><h5>Causas de rechazo</h5></div>"
            contenido += "<div class='row'><table>"
            for (var rechazo of tramite.causasRechazo){
              contenido += "<tr><td>"+rechazo.causaRechazo+"</td><td>"+rechazo.detalleRechazo+"</td></tr>"
            }
            contenido+= "</table></div>"
          }
          contenido += "<div class='row'><h5>Historial del trámite</h5></div> ";
          for (var hist of tramite.historial){
            
            var lineahist = this.incluir_historial(hist.historial, this.envService.codigosHistorial);
            if (lineahist != ''){
              contenido += "<div class='row'>" + lineahist + "<hr/> </div>"  
            }
            /*if (this.currentProfile.profile_name == "Funcionario Subsidio"){

            } else{
              contenido += "<div class='row'>" + hist.historial + "<hr/> </div>"  
            }*/
            
          }
          contenido += "</div>"
          //contenido += "<div *ngFor='let hist of tramite.historial' class='row'> hist.historial <hr/> </div> </div>"
          divElem.innerHTML = contenido;
          //ifr.innerHTML = "<p>" + tramite.historial + "</p>";
  }

  openModal(modalId: string, radicado: string) {
    const searchParameters: SearchParameters = new SearchParameters();
    // Cambiar Asignación Fecha Desde
    searchParameters.radicado = radicado;

    // INICIO Datos Obligatorios Para Consulta
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentProfile && this.currentUser) {
      // Asignar Perfil Actual
      searchParameters.currentProfileName = this.currentProfile.profile_name
        ? this.currentProfile.profile_name
        : '';
      // Asignar Tipo Identificacion Afiliado
      searchParameters.tipoIdfAfiliado = this.currentUser.TipoIdentificacion
        ? this.currentUser.TipoIdentificacion
        : '';
      // Asignar Número Identificación Afiliado
      searchParameters.idfAfiliado = this.currentUser.NoIdentificacion
        ? this.currentUser.NoIdentificacion
        : '';
      // Asignar Número de Identificación Empresa
      searchParameters.idfEmpresa = this.currentProfile.profile_company_id
        ? this.currentProfile.profile_company_id
        : '';
    }

    // console.log('Search start!');

    this.searchService
      .searchTramites(searchParameters)
      .subscribe(
        (response: TramiteAfiliado[]) => {

          // console.log('Search end!');
          const id = response[0].tocid;
          this.modalRadicado = radicado;
          const reg: RegExp = new RegExp(this.envService.tocid, 'g');
          const URL: string = this.envService.tvURL.replace(reg, id.toString());
          this._modalService.open(modalId);
          const ifr: HTMLIFrameElement = document.createElement('iframe');
          ifr.setAttribute('id', 'embeeded-frame');
          ifr.setAttribute('frameborder', '0');
          ifr.setAttribute('width', '100%');
          ifr.setAttribute('height', '100%');
          document.getElementById('iframe-goes-here').appendChild(ifr);
          ifr.contentWindow.location.replace(URL);
        },
        error => {

          // console.log('Search error!');
          const errorObject = error as HttpErrorResponse;
          if (errorObject.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(['/logout']);
            // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
            // location.replace(logBackURL);
          }
        }
      );
  }

  closeModal(id: string) {
    this._modalService.close(id);
    // document.getElementById('embeeded-frame').remove();
    document.getElementById('iframe-goes-here').removeChild(document.getElementById('embeeded-frame'));
  }
  incluir_historial(historial: string, codigos: any) {
    let historias = historial.split(/\r?\n/);
    var incluir = "";
    for (var historia of historias){
      for (var codigo of codigos){
        if (historia.indexOf(codigo) >= 0) {
          incluir += "<p>"+ historia + "</p>";
          this.lineasDetalle.push(historia);
        }
      }
    }
    return incluir;
  }

  downloadDetail(){
 
    let csvRows = [];
    //let headers = `Tipo de certificado:;${this.certificadoActual.TipoCertificado};;;Fecha de solicitud:;${this.certificadoActual.FechaSolicitud}`;
    //csvRows.push(headers);
    //headers = `Item;Tipo Id;No. Id;Generado;Radicado;Observaciones`;
    //csvRows.push(headers);
    if (this.lineasDetalle.length > 0){
      var esmasivo= false;
      if (this.lineasDetalle.length === 1){
        esmasivo = false;
      }else {
        var primeralinea = this.lineasDetalle[1];
        esmasivo = (primeralinea.indexOf("CO1") >= 0);
      }
      
      csvRows.push(`DETALLES TRAMITE: ${this.tramiteActual.radicado}`)
      if (esmasivo){
        csvRows.push(`Item;TIPO DOC;DOCUMENTO;APELLIDO1;NOMBRE;ESTADO`);
      }else {
        csvRows.push(`item; Detalles`);
      }

    let nrolinea = 1;
    this.lineasDetalle.forEach((det)=>{
      if (esmasivo){
        det = nrolinea + ";" +det.replace(/\s+/g, ";");
      }else{
        det = nrolinea +";" + det;
      }
      
      //let nrolinea = (Number(det.pos) * 1) +1;
      nrolinea++;
      csvRows.push(det);
    });

    const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]),csvRows.join('\n')], {type: 'text/csv;charset=utf-8'});
    const url = window.URL.createObjectURL(blob) 

    // Creating an anchor(a) tag of HTML 
    const a = document.createElement('a') 
  
    // Passing the blob downloading url  
    a.setAttribute('href', url) 
  
    // Setting the anchor tag attribute for downloading 
    // and passing the download file name 
    a.setAttribute('download', `Detalle_${this.tramiteActual.radicado}.csv`); 
  
    // Performing a download with click 
    a.click() 
    }
    
  }
}



